"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "250px"
    },
    attrs: {
      placeholder: "Enter Employee Code",
      clearable: ""
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery["employee.code"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "employee.code", $$v);
      },
      expression: "listQuery['employee.code']"
    }
  }), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "small",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")])], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "id",
      label: "ID",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      prop: "type",
      label: "Type"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      prop: "icon",
      label: "Icon"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      label: "Employee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.employee.name))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "220",
      prop: "content",
      label: "Content"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.status))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      prop: "coins",
      label: "Coins"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Created On"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Actions",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/game-levels/edit/" + scope.row.id
          }
        }, [_c("el-button", {
          attrs: {
            type: "primary",
            size: "mini",
            icon: "el-icon-edit"
          }
        })], 1)];
      }
    }])
  })], 1), _c("pagination", {
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;